// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3BXti","content":"ManualTimeModal_content__24oJD"};